import { FC } from 'react';

import generateImageQuickstartButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_design/generate_image_quickstart_button_click';
import { Button, Card, Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { HyperstarSparkleFilledSize16 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

import { setIsAiGenerationModalVisible } from 'store/models/aiImageGeneration';
import { selectQuickCampaignProfRoles } from 'store/models/createQuickCampaign';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/AdQuickCreate/ImageGeneration/ImageGeneration.module.less';

const TrlKeys = {
    label: 'create.campaign.image.generation.label',
    description: 'create.campaign.image.generation.description',
    button: 'create.campaign.image.generation.button',
};

export const ImageGeneration: FC = () => {
    const trl = useTrls();
    const dispatch = useDispatch();
    const { isMobile, isGtL } = useBreakpoint();

    const vacancyProfRoles = useSelector(selectQuickCampaignProfRoles);

    return (
        <MagritteFormField
            label={trl(TrlKeys.label)}
            input={
                <Card
                    borderRadius={16}
                    padding={isGtL ? 8 : 16}
                    paddingLeft={isGtL ? 16 : undefined}
                    style="secondary"
                    stretched
                >
                    <div className={styles.card}>
                        <div className={styles.description}>
                            <HyperstarSparkleFilledSize16 initialColor="negative" />
                            <Text Element="span" typography="label-2-regular">
                                {trl(TrlKeys.description)}
                            </Text>
                        </div>
                        <Button
                            mode="primary"
                            style={vacancyProfRoles.length > 0 ? 'constant' : 'accent'}
                            size="small"
                            disabled={vacancyProfRoles.length === 0}
                            onClick={() => {
                                generateImageQuickstartButtonClick();
                                dispatch(setIsAiGenerationModalVisible(true));
                            }}
                            data-qa="ad-quick-create-image-generation-button"
                            stretched={isMobile}
                        >
                            {trl(TrlKeys.button)}
                        </Button>
                    </div>
                </Card>
            }
        />
    );
};
